import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasDelayedEvents: true,
    needToStopTimerOnPeriodDurationEnd: true
  },
  actionTypes: {
    numberOfPlayersChangeEvents: [
      '2_MIN_PENALTY',
      '2_AND_2_MIN_PENALTY',
      'PLAYER_ON_PITCH'
    ]
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    playersCount: {
      home: 6,
      away: 6
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    getOvertimePeriodName: 'OT',
    shootoutPeriodName: 'SO',
    shootoutStatisticTitle: 'trader.penalty.shootout.score.throws'
  }
}
